// src/components/layout/MobileShell.tsx
import React, { useEffect, useState } from "react";
import { Drawer, Box } from "@mui/material";
import Header from "./Header";
import SidebarContent from "./SidebarContent";

type Props = {
  hideSidebar: boolean;
  children: React.ReactNode;
};

const MobileShell: React.FC<Props> = ({ hideSidebar, children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    const prevHtmlOverflow = html.style.overflow;
    const prevBodyOverflow = body.style.overflow;
    const prevBodyPosition = body.style.position;
    const prevBodyWidth = body.style.width;

    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
    body.style.position = "fixed";
    body.style.width = "100%";

    return () => {
      html.style.overflow = prevHtmlOverflow;
      body.style.overflow = prevBodyOverflow;
      body.style.position = prevBodyPosition;
      body.style.width = prevBodyWidth;
    };
  }, []);

  return (
    <>
      <Header
        showNavButton={!hideSidebar}
        onOpenNav={() => setDrawerOpen(true)}
      />

      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      >
        <Box sx={{ width: 280, height: "100vh" }}>
          <SidebarContent
            variant="drawer"
            onNavigate={() => setDrawerOpen(false)}
          />
        </Box>
      </Drawer>

      <div className="fixed inset-0 pt-14 overflow-hidden">
        <main className="h-full min-h-0 overflow-auto">{children}</main>
      </div>
    </>
  );
};

export default MobileShell;